export default __webpack_public_path__ + "static/media/mail-error.0f6025da.gif";